export const LOGO_ICON = "/images/logo-icon.webp";
export const LOGO_FULL = "/images/logo-full.png";
export const LOGO_ROUNDED = "/images/logo-round.jpg";
export const PATTERN = "/images/pattern.webp";
export const IMAGE_404 = "/images/image-404.webp";
export const WORKER_AVATAR = "/images/avatar/worker.png";
export const VENDOR_AVATAR = "/images/avatar/vendor.png";
export const SUBCONTRACTOR_AVATAR = "/images/avatar/subcontractor.png";
export const CLIENT_AVATAR = "/images/avatar/client.png";
export const EMPLOYEE_AVATAR = "/images/avatar/employee.png";
export const USER_AVATAR = "/images/avatar/user.png";
